(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-upsell"] && !Shopify.designMode) return;
  try {
    
  class CartUpsell {
    constructor() {
      this.sectionId = window.cartUpsellSectionId;
      this.upsellProductIds = window.cartUpsellProductIds || [];
      this.sectionElement = document.getElementById('shopify-section-' + this.sectionId);
      
      if (!this.sectionElement) {
        return;
      }
      
      this.init();
    }

    init() {
      this.attachButtonListeners();
      this.setupCartMonitoring();
      this.checkCartAndUpdate();
    }

    attachButtonListeners() {
      const buttons = this.sectionElement.querySelectorAll('.cart-upsell__add-button:not([disabled])');
      
      buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          this.handleAddToCart(e);
        });
      });
    }

    setupCartMonitoring() {
      // Monitor the cart form for changes
      const cartForm = document.querySelector('form[action$="/cart"]');
      if (cartForm) {
        cartForm.addEventListener('submit', () => {
          setTimeout(() => this.checkCartAndUpdate(), 1000);
        });
        
        // Monitor all input changes in the cart
        cartForm.addEventListener('change', () => {
          setTimeout(() => this.checkCartAndUpdate(), 500);
        });
      }

      // Monitor remove buttons
      document.addEventListener('click', (e) => {
        if (e.target.closest('[href*="cart/change"], [href*="updates"], cart-remove-button')) {
          setTimeout(() => this.checkCartAndUpdate(), 1000);
        }
      });

      // Listen for cart drawer updates (if using Dawn cart drawer)
      document.addEventListener('cart:updated', () => {
        this.checkCartAndUpdate();
      });
    }

    async checkCartAndUpdate() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Check if Rock Sliders are in cart
        const hasEligibleProduct = cart.items.some(item => item.product_type === 'Rock Sliders');
        
        if (!hasEligibleProduct) {
          // Remove upsell products and hide section
          await this.removeUpsellProducts(cart);
          this.sectionElement.style.display = 'none';
        } else {
          // Show section
          this.sectionElement.style.display = '';
        }
        
      } catch (error) {
        console.error('Cart check error:', error);
      }
    }

    async removeUpsellProducts(cart) {
      if (!this.upsellProductIds || this.upsellProductIds.length === 0) {
        return false;
      }
      
      // Find upsell items in cart
      const upsellItems = cart.items.filter(item => 
        this.upsellProductIds.includes(String(item.product_id))
      );
      
      if (upsellItems.length === 0) {
        return false;
      }
      
      // Build updates object to set quantity to 0
      const updates = {};
      upsellItems.forEach(item => {
        updates[item.key] = 0;
      });
      
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        });
        
        if (response.ok) {
          window.location.reload();
          return true;
        }
      } catch (error) {
        console.error('Remove error:', error);
      }
      
      return false;
    }

    async handleAddToCart(event) {
      const button = event.currentTarget;
      const variantId = button.dataset.variantId;
      const productTitle = button.dataset.productTitle;
      
      if (!variantId) {
        return;
      }

      this.setButtonLoading(button, true);

      try {
        const formData = {
          items: [{
            id: variantId,
            quantity: 1
          }]
        };

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (!response.ok) {
          throw new Error('Failed to add item');
        }

        const data = await response.json();
        
        // Update cart UI
        await this.updateCartCount();
        
        // Reload page to show updated cart
        window.location.reload();
        
      } catch (error) {
        console.error('Add to cart error:', error);
        alert('Unable to add item to cart. Please try again.');
      } finally {
        this.setButtonLoading(button, false);
      }
    }

    setButtonLoading(button, isLoading) {
      const textSpan = button.querySelector('.cart-upsell__add-button-text');
      const loadingSpan = button.querySelector('.cart-upsell__add-button-loading');
      
      if (isLoading) {
        button.classList.add('loading');
        button.disabled = true;
        if (textSpan) textSpan.style.display = 'none';
        if (loadingSpan) loadingSpan.style.display = 'flex';
      } else {
        button.classList.remove('loading');
        button.disabled = false;
        if (textSpan) textSpan.style.display = 'inline';
        if (loadingSpan) loadingSpan.style.display = 'none';
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        // Update cart count badges
        const countElements = document.querySelectorAll('[data-cart-count], .cart-count-bubble span, #cart-icon-bubble');
        countElements.forEach(element => {
          element.textContent = cart.item_count;
        });
      } catch (error) {
        console.error('Cart count update error:', error);
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new CartUpsell();
    });
  } else {
    new CartUpsell();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
